import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ChequesSemFundos } from 'src/app/models/dividasPendentes/dividas.cheques-sem-fundos';
import { FalhaServico } from 'src/app/models/falha-servico';
import { UtilLarguraTela } from 'src/app/utils/configuracoes/util-largura-tela';
import { MensagemRetorno } from 'src/app/utils/mensagens.retorno';
import { FotografiaService } from '../../../fotografia/fotografia.service';
import { BlocoDividasChequeSemFundoService } from './bloco-dividas-cheque-sem-fundo.service';

@Component({
  selector: 'app-bloco-dividas-cheque-sem-fundo',
  templateUrl: './bloco-dividas-cheque-sem-fundo.component.html',
  styleUrls: ['./bloco-dividas-cheque-sem-fundo.component.scss']
})
export class BlocoDividasChequeSemFundoComponent implements OnInit {

  constructor(private fotografiaService: FotografiaService, private blocoDividasChequeSemFundoService : BlocoDividasChequeSemFundoService) { }
  public larguraEhSuperiorMin: boolean;
  public listaServicoFalha: Array<string>;
  public falhaServico: FalhaServico;
  public chequesSemFundos: ChequesSemFundos;
  @Output() totalizadorDividasChequeSemFundo: EventEmitter<number> = new EventEmitter();
  @Input() recebeLoadingEvento: boolean;
  @Output() emiteLoadingEvento = new EventEmitter();


  ngOnInit(): void {
    this.chequesSemFundos = new ChequesSemFundos();
    this.falhaServico = new FalhaServico();
    this.listaServicoFalha = new Array();
    this.larguraEhSuperiorMin = UtilLarguraTela.checarLarguraTela(); 
    
    this.consultarDividasPendentesChequesSemFundos();
  }

  capturaErro(retornoErro: any, servico: string) {
    this.chequesSemFundos.falhaServico = retornoErro.error[0];
    this.chequesSemFundos.falhaServico.bloco = servico;
    this.listaServicoFalha.push(servico);
    if(retornoErro.status !== 404){
      this.chequesSemFundos.falhaServico.message = MensagemRetorno.mensagemRetornoStatus(retornoErro.status);
    }
    
  }

  consultarDividasPendentesChequesSemFundos() {
    this.blocoDividasChequeSemFundoService.consultarDividasPendentesChequesSemFundos().subscribe(res => {
      this.chequesSemFundos.resultados = res.resultados;
      this.fotografiaService.concatenarFotografia(res.resultados, 'bloco-cheques-sem-fundo');
      this.totalizadorDividasChequeSemFundo.emit(res.resultados.length > 0 ? res.resultados.length : 0);
      this.chequesSemFundos.falhaServico.message = res.resultados.length > 0 ? "" : MensagemRetorno.mensagemRetornoStatus('200');
    }, err => {
        this.capturaErro(err, 'bloco-cheques-sem-fundo');
        this.fotografiaService.concatenarFotografia(err, 'bloco-cheques-sem-fundo');
      })
      .add(() => this.emiteLoadingEvento.emit("bloco-cheques-sem-fundo"));
    }


}
